module.exports = __webpack_public_path__ + "static/index/img/baikal-901.21c5baa8.jpg";